<div id="body"
     class="flex-box">
    <!-- loading image -->
    <div class="page-content">
        <div style="position:relative;">
            <div class="page-box-1 height-300">
                <h1 class="heading-1">Cancellation fee</h1>

                <div class="tag-box tag-box-v3 no-padding-side padding-bottom-regular padding-top-regular">
                    <div class="row margin-bottom-small">
                        <div class="col-sm-offset-1 col-sm-10 text-center">
                            <p><strong>You have been charged a $50 cancellation fee. We hope you book with Wrench in the future. Have a nice day!</strong></p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-offset-2 col-sm-4">
                            <button type="button"
                                    class="btn-u btn-block"
                                    data-cy="cancelFeeBookAppointment"
                                    [routerLink]="['/book']">Book Appointment
                            </button>

                        </div>

                        <div class="col-sm-4">
                            <a class="btn-u btn-u-alternate btn-block" type="button" [routerLink]="['/appointments']">
                                No Thanks
                            </a>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
